import React, { useState, useEffect, useRef } from 'react'
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { statusDisponibles } from '../../ComponentsCat/Constantes/constantes';
import { TextoAdvertencia, MensajeAdvertencia } from '../../ComponentsCat/Mensajes/Mensajes';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import { TabView, TabPanel } from 'primereact/tabview';
import { useHistory } from 'react-router-dom';
import { Service } from '../../../../service/Service';
import Environment from '../../../../Environment';
import { CLIENTE, LICENCIAS_CLIENTES_DASHBOARD } from '../../../../genericos/Uris';
import { Toast } from 'primereact/toast';
import Spinner from './../../../../components/loader/Spinner';

const CrearModificar = ({
    productDialog,
    titulos,
    hideDialog,
    product,
    updateField,
    tieneId,
    estiloNombre, setEstiloNombre,
    estiloApellido, setEstiloApellido,
    estiloPersona, setEstiloPersona,
    estiloRazonSocial, setEstiloRazonSocial,
    estiloRfc, setEstiloRfc,
    estiloEmail, setEstiloEmail,
    estiloCp, setEstiloCp,
    estiloCiudad, setEstiloCiudad,
    estiloNumeroExt, setEstiloNumeroExt,
    estiloNumeroInt, setEstiloNumeroInt,
    estiloDelegacionMunicipio, setEstiloDelegacionMunicipio,
    estiloCalle, setEstiloCalle,
    notificaciones, setIsLoading, setError, setProducts,
    clienteVacio, setProduct, setProductDialog,
    licencia, setLicencia, hideInputs, setHideInputs, setLoadingButton, loadingButton
}) => {
    const clienteService = new Service();
    const licenciaService = new Service();
    const getRoute = Environment();
    const toast = useRef(null);
    const [direccion, setDireccion] = useState({
        calle: "",
        colonia: "",
        cp: "",
        ciudad: "",
        numeroExt: "",
        numeroInt: "",
        delegacionMunicipio: ""
    });

    const updateFieldDireccion = (data, field) => {
        setDireccion({
            ...direccion,
            [field]: data,
        });
    }


    // const [hideInputs, setHideInputs] = useState(true);
    const [datosInvalidos, setDatosInvalidos] = useState(false)     // Validar envio
    const [campoInvalido, setCampoInvalido] = useState(false)
    const [mensaje, setMensaje] = useState("")                      // Mensaje para envio
    const [texto, setTexto] = useState("")                          // Mensaje para input
    const [controlador, setControlador] = useState(0)
    const [persona, setPersona] = useState('');
    const [lenRfc, setLenRfc] = useState(0);
    const [botonSiguiente, setBotonSiguiente] = useState(true)
    const [showLicencia, setShowLicencia] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [errorToSave, setErrorToSave] = useState(false);
    const [messageError, setMessageError] = useState("");
    const [hideButtonSave, setHideButtonSave] = useState(false);

    // if(persona !== undefined) setHideInputs(false);

    //--------------------| Validar campos  |--------------------
    const ValidarNombre = (texto) => {
        const expresion = /^([a-zA-Z\sÁÉÍÓÚáéíóúÑñ]+)$/
        if (!expresion.test(texto)) {
            setEstiloNombre("p-invalid")
            setTexto("Campo invalido")
            setCampoInvalido(true);
            setDisabled(true)
        } else {
            setEstiloNombre("")
            setTexto("")
            setCampoInvalido(false)
            setDisabled(false)
        }
    }
    const ValidarApellido = (texto) => {
        const expresion = /^([a-zA-Z\sÁÉÍÓÚáéíóúÑñ]+)$/
        if (!expresion.test(texto)) {
            setEstiloApellido("p-invalid")
            setTexto("Campo invalido")
            setCampoInvalido(true)
            setDisabled(true)
        } else {
            setEstiloApellido("")
            setTexto("")
            setCampoInvalido(false)
            setDisabled(false)
        }
    }
    const ValidarRazonSocial = (texto) => {
        // const expresion = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s\-0-9']+$/;
        const expresion = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s\-0-9'.]+$/;
        if (!expresion.test(texto)) {
            setEstiloRazonSocial("p-invalid")
            setTexto("Campo invalido")
            setCampoInvalido(true)
            setDisabled(true)
        } else {
            setEstiloRazonSocial("")
            setTexto("")
            setCampoInvalido(false)
            setDisabled(false)
        }
    }
    const validarEmail = (texto) => {
        const expresion = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
        if (!expresion.test(texto)) {
            setEstiloEmail("p-invalid")
            setTexto("Campo invalido")
            setCampoInvalido(true)
            setDisabled(true)
        } else {
            setEstiloEmail("")
            setTexto("")
            setCampoInvalido(false)
            setDisabled(false)
        }
    }
    const validarCalle = (texto) => {
        const expresion = /^([a-zA-Z\sÁÉÍÓÚáéíóúÑñ]+)$/
        if (!expresion.test(texto)) {
            setEstiloEmail("p-invalid")
            setTexto("Campo invalido")
            setCampoInvalido(true)
            setDisabled(true)
        } else {
            setEstiloEmail("")
            setTexto("")
            setCampoInvalido(false)
            setDisabled(false)
        }
    }
    const validarNumExt = (texto) => {
        const expresion = /^([a-zA-Z\sÁÉÍÓÚáéíóúÑñ]+)$/
        if (!expresion.test(texto)) {
            setEstiloEmail("p-invalid")
            setTexto("Campo invalido")
            setCampoInvalido(true)
            setDisabled(true)
        } else {
            setEstiloEmail("")
            setTexto("")
            setCampoInvalido(false)
            setDisabled(false)
        }
    }
    const validarNumInt = (texto) => {
        const expresion = /^([a-zA-Z\sÁÉÍÓÚáéíóúÑñ]+)$/
        if (!expresion.test(texto)) {
            setEstiloEmail("p-invalid")
            setTexto("Campo invalido")
            setCampoInvalido(true)
            setDisabled(true)
        } else {
            setEstiloEmail("")
            setTexto("")
            setCampoInvalido(false)
            setDisabled(false)
        }
    }
    const validarTexto = (texto) => {
        const expresion = /^([a-zA-Z\sÁÉÍÓÚáéíóúÑñ]+)$/
        if (!expresion.test(texto)) {
            setEstiloEmail("p-invalid")
            setTexto("Campo invalido")
            setCampoInvalido(true)
            setDisabled(true)
        } else {
            setEstiloEmail("")
            setTexto("")
            setCampoInvalido(false)
            setDisabled(false)
        }
    }
    const validateDP = () => {
        if (persona === 'moral') {
            product.apellidos = null;
            product.esFisica = false
        }
        if (product.nombreRazon === "" ||
            product.apellidos === "" ||
            product.rfc === "" ||
            product.email === ""
        ) {
            setMensaje("Todos los campos son obligatorios");
            setDatosInvalidos(true);
            setDisabled(true);
            setTimeout(() => { setDatosInvalidos(false) }, 3000);
            return;
        } else {
            setControlador(1);
            setBotonSiguiente(false);
            setDisabled(false);
        }
    }
    const validateDireccion = () => {
        if (direccion.calle === "" ||
            direccion.colonia === "" ||
            direccion.cp === "" ||
            direccion.delegacionMunicipio === "" ||
            direccion.ciudad === "" ||
            direccion.numeroExt === ""
        ) {
            setMensaje("Todos los campos son obligatorios");
            setDatosInvalidos(true);
            setTimeout(() => { setDatosInvalidos(false); }, 3000);

            return;
        }
        product.direccion = direccion;
        saveProduct();
    }
    const [idCliente, setIdCliente] = useState(null);
    const saveProduct = () => {
        if (!product.id) { createProduct(product) }
        else { updateProduct(product) }
    }
    const createProduct = async () => {
        clienteService.baseUrl = `${getRoute}/${CLIENTE}`;
        setLoadingButton(true);
        try {
            setHideButtonSave(true);
            const res = await clienteService.create(product);
            setIdCliente(res.id);

            const data = await clienteService.readAll();
            setProducts(data);

            toast.current.show({ severity: 'success', summary: '¡Atención!', detail: `${notificaciones.creacion}`, life: 3000 });
            setLoadingButton(false);
            hideCreate();
            setProductDialog(false);

            setShowLicencia(true);
            setHideButtonSave(false);
        } catch (error) {
            setLoadingButton(false);
            setHideButtonSave(false);
            setMessageError(error.response.data)
            setErrorToSave(true);
            setTimeout(() => { setErrorToSave(false); }, 5000)
        }
    }
    const updateProduct = async (product) => {
        setLoadingButton(true);
        setError(null)
        try {
            clienteService.baseUrl = `${getRoute}/${CLIENTE}/${product.id}`;
            await clienteService.update(product);
            clienteService.baseUrl = `${getRoute}/${CLIENTE}`;
            const data = await clienteService.readAll();
            console.log("editado")
            toast.current.show({ severity: 'success', summary: '¡Atención!', detail: `${notificaciones.modificacion}`, life: 3000 });
            hideCreate();
            setProducts(data)
        } catch (error) {
            setLoadingButton(false);
            setHideButtonSave(false);
            setMessageError(error.response.data)
            setErrorToSave(true);
            setTimeout(() => { setErrorToSave(false); }, 5000)
        }
    }
    const botones = () => {
        if (botonSiguiente) {
            return (
                <div className='flex justify-content-between flex-wrap'>
                    <Button label="Cancelar" icon="pi pi-times" iconPos="right" severity="success" onClick={hideCreate} />
                    {disabled ? (<>
                        <Button label="Siguiente" icon="pi pi-check" iconPos="right" severity="danger" disabled onClick={validateDP} />
                    </>) : (<>
                        <Button label="Siguiente" icon="pi pi-check" iconPos="right" severity="danger" onClick={validateDP} />
                    </>)}
                </div>
            )
        }
        else {
            return (
                <>
                    {hideButtonSave ? (<></>) : (<>
                        <div className='flex justify-content-between flex-wrap'>
                            <Button label="Atras" icon="pi pi-times" iconPos="right" severity="success" onClick={() => { setControlador(0); setBotonSiguiente(true); }} />
                            <Button label="Guardar" icon="pi pi-check" iconPos="right" severity="danger" onClick={validateDireccion} />
                        </div>
                    </>)}
                </>
            )
        }
    }

    const botonesLicencia = () => {
        return (
            <div className='flex justify-content-between flex-wrap'>
                <Button label="Cancelar" icon="pi pi-times" iconPos="right" severity="success" onClick={hideLicencia} />
                <Button label="Continuar" icon="pi pi-check" iconPos="right" severity="danger" onClick={continuarLicencia} />
            </div>
        )
    }
    const continuarLicencia = () => {
        hideLicencia();
        redirectLicencia();
        setControlador(0);
    }
    const hideCreate = () => {
        setProduct(clienteVacio);
        setDireccion({
            calle: "",
            colonia: "",
            cp: "",
            ciudad: "",
            numeroExt: "",
            numeroInt: "",
            delegacionMunicipio: ""
        })
        hideDialog();
        setBotonSiguiente(true);
        setControlador(0);
    }
    const funcionControlador = (e) => { setControlador(e.index) }

    const hideLicencia = () => {
        setShowLicencia(false);
        hideCreate();
    }
    // --> Redireccionar a licencias
    const history = useHistory();
    const redirectLicencia = () => { history.push(`/${LICENCIAS_CLIENTES_DASHBOARD}/${idCliente}`) }

    useEffect(() => {
        if (product.id !== null) {
            if (product.esFisica) {
                setPersona('fisica')
            }
            else {
                setPersona('moral');
            }
            setDireccion(product.direccion);
        }
    }, [product])

    useEffect(() => {
        if (persona) { setHideInputs(false) }
        else { setHideInputs(true) }
    }, [persona])

    //--------------------| Valor que regresara  |--------------------
    return (
        <>
            <Toast ref={toast} />
            <Dialog
                visible={productDialog} onHide={hideCreate}
                footer={loadingButton || botones} header={titulos.VentanaCrear}
                style={{ width: '450px' }} modal className="p-fluid" >
                {loadingButton ? (<> <Spinner /> </>) : (<>
                    <TabView activeIndex={controlador} onTabChange={(e) => funcionControlador(e)}>
                        <TabPanel disabled header="Datos personales" leftIcon="pi pi-user mr-2">
                            {tieneId ?
                                <div className='field'>
                                    <div className='gird mb-3'>
                                        <label>* Persona</label>
                                    </div>
                                    <div className='flex flex-wrap gap-3'>
                                        <div className='flex align-items-center'>
                                            <RadioButton inputId="fisica" name="razon" value="fisica" onChange={(e) => { setPersona(e.value); setHideInputs(false) }} checked={persona === 'fisica'} />
                                            <label htmlFor="fisica" className="ml-2">Persona física</label>
                                        </div>
                                        <div className='flex align-items-center'>
                                            <RadioButton inputId="moral" name="razon" value="moral" onChange={(e) => { setPersona(e.value); setHideInputs(false) }} checked={persona === 'moral'} />
                                            <label htmlFor="moral" className="ml-2">Persona moral</label>
                                        </div>
                                    </div>
                                </div> : <></>
                            }
                            {persona === "fisica" && (
                                <div>
                                    <div className="field">
                                        <label htmlFor="nombre">* Nombre</label>
                                        <InputText
                                            id="nombre"
                                            value={product.nombreRazon}
                                            onChange={(e) => {
                                                updateField(e.target.value, "nombreRazon")
                                                ValidarNombre(e.target.value)
                                            }}
                                            required className={estiloNombre} maxLength="50" />
                                        {estiloNombre && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                                    </div>

                                    <div className="field">
                                        <label htmlFor="apellidos">* Apellidos</label>
                                        <InputText
                                            id="apellidos"
                                            value={product.apellidos}
                                            onChange={(e) => {
                                                updateField(e.target.value, "apellidos")
                                                ValidarApellido(e.target.value)
                                            }}
                                            required className={estiloApellido} maxLength="100" />
                                        {estiloApellido && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                                    </div>
                                </div>
                            )}

                            {persona === "moral" && (
                                <div className="field">
                                    <label htmlFor="razonSocial">* Razón Social</label>
                                    <InputText
                                        id="razonSocial"
                                        value={product.nombreRazon}
                                        onChange={(e) => {
                                            updateField(e.target.value, "nombreRazon")
                                            ValidarRazonSocial(e.target.value)
                                        }}
                                        required className={estiloRazonSocial} maxLength="100" />
                                    {estiloRazonSocial && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                                </div>
                            )}

                            {hideInputs && (
                                <div className="text-center font-bold my-4" style={{ color: "#818181" }}>
                                    Por favor selecciona el tipo de persona
                                </div>
                            )}
                            {!hideInputs && (
                                <>
                                    <div className="field">
                                        <label htmlFor="rfc">* Número de identificación fiscal</label>
                                        <InputText
                                            id="rfc"
                                            value={product.rfc}
                                            onChange={(e) => updateField(e.target.value, "rfc")}
                                            required className={estiloRfc} maxLength="15" />
                                        {estiloRfc && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                                    </div>
                                </>
                            )}
                            <div className="field">
                                <label htmlFor="email">* e-mail</label>
                                <InputText
                                    id="email"
                                    value={product.email}
                                    onChange={(e) => {
                                        updateField(e.target.value, "email")
                                        validarEmail(e.target.value)
                                    }}
                                    required className={estiloEmail} maxLength="100" />
                                {estiloEmail && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                            </div>

                            {!tieneId && (
                                <>
                                    <div className="field">
                                        <label>Estatus</label>
                                        <Dropdown
                                            value={product.idEstatus}
                                            options={statusDisponibles} onChange={e => updateField(e.value, "idEstatus")}
                                            optionLabel="status" placeholder="--Selecciona un status--"
                                        />
                                    </div>
                                    {/* <div className="field">
                                        <label>* Licencia</label>
                                        <InputText
                                            id="licencia"
                                            value={licencia}
                                            onChange={(e) => setLicencia(e.target.value,)}
                                            required className={estiloEmail} maxLength="25" />
                                    </div> */}
                                </>
                            )}
                            {datosInvalidos && <MensajeAdvertencia>{mensaje}</MensajeAdvertencia>}

                            <small id="username-help">Los campos con * son obligatorios.</small>
                        </TabPanel>

                        <TabPanel disabled header="Dirección" leftIcon="pi pi-calendar mr-2">
                            <div className="field">
                                <label htmlFor="calle">* Calle</label>
                                <InputText
                                    id="calle"
                                    value={direccion.calle}
                                    onChange={(e) => {
                                        updateFieldDireccion(e.target.value, "calle")
                                        validarCalle(e.target.value)
                                    }}
                                    required className={estiloCalle} maxLength="50" />
                                {estiloCalle && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                            </div>

                            <div className='flex flex-row flex-wrap'>
                                <div className="field col-6">
                                    <label htmlFor="numeroExt">* Número Exterior</label>
                                    <InputText
                                        id="numeroExt"
                                        value={direccion.numeroExt}
                                        onChange={(e) => {
                                            updateFieldDireccion(e.target.value, "numeroExt")
                                            validarNumExt(e.target.value)
                                        }}
                                        required className={estiloNumeroExt} maxLength="10" />
                                    {estiloNumeroExt && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                                </div>
                                <div className="field col-6">
                                    <label htmlFor="numeroInt">Número Interior</label>
                                    <InputText
                                        id="numeroInt"
                                        value={direccion.numeroInt}
                                        onChange={(e) => {
                                            updateFieldDireccion(e.target.value, "numeroInt")
                                            validarNumInt(e.target.value)
                                        }}
                                        required className={estiloNumeroInt} maxLength="10" />
                                    {estiloNumeroInt && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                                </div>
                            </div>
                            <div className="field">
                                <label htmlFor="colonia">* Colonia</label>
                                <InputText
                                    id="colonia"
                                    value={direccion.colonia}
                                    onChange={(e) => {
                                        updateFieldDireccion(e.target.value, "colonia")
                                        validarTexto(e.target.value)
                                    }}
                                    required className={estiloNombre} maxLength="50" />
                                {estiloNombre && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                            </div>
                            <div className="field">
                                <label htmlFor="cp">Código Postal</label>
                                <InputText
                                    id="cp"
                                    value={direccion.cp}
                                    onChange={(e) => {
                                        updateFieldDireccion(e.target.value, "cp")
                                        validarTexto(e.target.value)
                                    }}
                                    required className={estiloCp} maxLength="10" />
                                {estiloCp && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                            </div>
                            <div className="field">
                                <label htmlFor="delegacionMunicipio">* Delegación o Municipio</label>
                                <InputText
                                    id="delegacionMunicipio"
                                    value={direccion.delegacionMunicipio}
                                    onChange={(e) => {
                                        updateFieldDireccion(e.target.value, "delegacionMunicipio")
                                        validarTexto(e.target.value)
                                    }}
                                    required className={estiloDelegacionMunicipio} maxLength="100" />
                                {estiloDelegacionMunicipio && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                            </div>
                            <div className="field">
                                <label htmlFor="ciudad">* Ciudad</label>
                                <InputText
                                    id="ciudad"
                                    value={direccion.ciudad}
                                    onChange={(e) => {
                                        updateFieldDireccion(e.target.value, "ciudad")
                                        validarTexto(e.target.value)
                                    }}
                                    required className={estiloCiudad} maxLength="100" />
                                {estiloCiudad && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                            </div>

                            {datosInvalidos && <MensajeAdvertencia>{mensaje}</MensajeAdvertencia>}


                            <small id="username-help">Los campos con * son obligatorios.</small>
                        </TabPanel>
                    </TabView>
                    {errorToSave && <MensajeAdvertencia>{messageError}</MensajeAdvertencia>}
                </>)}

            </Dialog>

            {/* Confirmar para crear una licencia */}
            <Dialog visible={showLicencia} onHide={hideLicencia} footer={botonesLicencia} style={{ width: '550px' }} modal className="p-fluid">
                <div className="confirmation-content">
                    <i className="pi pi-check-circle mr-3" style={{ fontSize: '2rem' }} />
                    {product && <span style={{ fontSize: '2rem' }} >¿Deseas asignar una licencia?</span>}
                </div>
            </Dialog>

        </>
    )
}
export default CrearModificar